module.exports = __webpack_public_path__ + "img/first-job-2-min.7b794124.png";